import { createSelector } from "reselect"
import { get } from "lodash"

const getModuleSelectedDate = state => get(state, "modules.litmus.selectedDate")
const getHistoricalSelectedDate = (_, props) => get(props, "selectedDate")

export const getSelectedDate = createSelector(
  [getModuleSelectedDate, getHistoricalSelectedDate],
  (moduleSelectedDate, historicalSelectedDate) => moduleSelectedDate || historicalSelectedDate,
)
